import getNow from 'lodash/now'

export function formatImageByImageMogr2 (url, options) {
  if (!url) return ''
  const base = window.location.host === 'sspai.com' ? 'https://cdnfile.sspai.com/' : 'https://test-images.sspai.com/'
  url = url.indexOf('http') === 0 ? url : url[0] === '/' ? `${base}${url.slice(1)}` : `${base}${url}`
  if (!options) return url
  const isSupportWebp = typeof window === 'undefined' || window.isSupportWebp
  const useWebpFormat = isSupportWebp ? 'format/webp/' : ''
  const { mode, w = '', h = '', quality = 90 } = options
  let prompt = ''
  switch (mode) {
    case 'crop':
      prompt = `/${useWebpFormat}auto-orient/quality/${quality}/thumbnail/!${w}x${h}r/gravity/Center/crop/${w}x${h}/interlace/1`
      break
    default:
      prompt = `/${useWebpFormat}auto-orient/quality/${quality}/interlace/1`
      break
  }
  return `${url}?imageMogr2${prompt}`
}

// 格式化整数
export function formatInteger (num) {
  const integer = Math.round(num)
  if (integer < 10) return `0${integer}`
  return integer
}

export function formatDate (v) {
  const now = new Date(getNow())
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const date = new Date(v)
  const diffToday = date - today
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  if (diffToday >= 0) {
    // 当天
    return `TODAY`
  } else {
    return `${now.getFullYear() === year ? '' : `${year}.`}${formatInteger(month)}.${formatInteger(day)}`
  }
}
